module.exports = __webpack_public_path__ + "static/media/slide-7.17e135b5.jpg";